import React from 'react';
import styled from 'styled-components';
// import Header from '../navigation/headers/Headers';
// import Footer from '../navigation/footers/Footers';
import { useEffect, useRef } from 'react';
import { Outlet, useLocation } from 'react-router-dom';
import Footer from '../navigation/footer/EPL_Footer';
import Header from '../navigation/header/header-main/EPL_Header';

const PageContainerWrapper = styled.div`
    display: flex;
    flex-direction: column;
    // justify-content: space-evenly;
    height: 100%;
    min-height: 100vh;
    font-size: 1.8rem;
    background-color: #f8f8f8;
    html {
        scorll-behavior: smooth;
    }
    #children{
        // align-items: center;
        // margin-bottom: 50px;
        // max-width: 1267px;
        // margin-left: 45px;
        // min-height: 100vh;
        display: flex;
        flex-direction: column;
        flex: 1;
    }

    @media screen and (max-width: 1200px) {
        font-size: 1.7rem;
    }
    @media screen and (max-width: 1080px) {
        font-size: 1.6rem;
    }
    @media screen and (max-width: 720px) {
        font-size: 1.5rem;
    }
    @media screen and (max-width: 480px) {
        font-size: 1.4rem;
    }
    @media screen and (max-width: 360px) {
        font-size: 1.3rem;
    }
    @media screen and (max-width: 320px) {
        font-size: 1.2rem;
    }
    @media screen and (max-width: 280px) {
        font-size: 1.1rem;
    }
    @media screen and (max-width: 240px) {
        font-size: 1rem;
    }
`;

const PageContainer = ({ children }) => { 
    const location = useLocation();
    const contentRef = useRef(null);

    useEffect(() =>{
        // console.log("Changed Route");
        // Access location information
        // console.log(location);
        // console.log(location.pathname); // Current path
        if(!["/login", "/index"].includes(location.pathname)) {
            if(contentRef.current) {
                contentRef.current.scrollIntoView();
            }
        }
    }, []);
    return (
        <PageContainerWrapper>
            <Header />
            <div ref={contentRef} id="content">
                <Outlet id="children" />{children}
            </div>
            {window.location.href.split("/")[window.location.href.split("/").length - 1].slice(0,5)=== "index" ?<></>:<Footer source={window.location.href.split("/")[window.location.href.split("/").length - 2]} visible={true} /> }
        </PageContainerWrapper>
    );
};

export default PageContainer;